import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawCloseIcon from "./RawCloseIcon.svg.jsx";

const CloseIcon = forwardRef((props, ref) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={RawCloseIcon}
      data-testid="close-icon"
      {...props}
    />
  );
});

export default CloseIcon;
